import { FeatureFlag } from '@ps/web-core-enums';
import { useFeature } from '@ps/web-core-store';
import type { Menu } from '@ps/web-martech-cms-types';
import { useNavigate } from '@ps/web-shared-components';
import classNames from 'clsx';
import { useEffect, useState } from 'react';
import { useLocation } from 'react-router';

import getBackgroundImageStyle from '@swf/core/utils/getBackgroundImageStyle';

import CMSNavigationItem from '../CMSNavigation/components/CMSNavigationItem/CMSNavigationItem';

import styles from './CMSSecondaryMenuV3.scss';

interface Props {
  menu: Menu;
  maxDepth: number;
  menuItems?: { name: string; url: string }[];
}

const CMSSecondaryMenuV3: React.FC<Props> = ({ menu, maxDepth, menuItems }) => {
  const { pathname } = useLocation();
  const { highlighted_item: highlightedItem } = menu;
  const isPrototype3Enabled = useFeature(FeatureFlag.PKRNavDesignV2);

  const navigate = useNavigate();
  const [activeItem, setActiveItem] = useState('');

  useEffect(() => {
    const foundItem = menuItems?.find((menuItem) => menuItem.url === pathname);
    if (foundItem?.url) {
      setActiveItem(foundItem.url);
    }
  }, [pathname, menuItems]);

  return (
    <div
      className={classNames(styles.wrapper, {
        [styles.wrapperPrototype2]: isPrototype3Enabled
      })}
    >
      <div className={styles.secondaryMenu}>
        <ul className={styles.secondaryMenuList}>
          {menuItems?.map((menuItem, index) => (
            <li
              key={index}
              onClick={() => {
                setActiveItem(menuItem.url);
                navigate(menuItem.url);
              }}
              className={classNames(styles.secondaryMenuItem, {
                [styles.active]: activeItem === menuItem.url
              })}
            >
              {menuItem.name}
            </li>
          ))}
        </ul>
      </div>
      {!!highlightedItem?.item?.length && (
        <li
          key={highlightedItem.item[0].uid}
          className={classNames(styles.topLevel, styles.highlighted, {
            [styles.withBackgroundImage]: highlightedItem.background_image?.url
          })}
          style={getBackgroundImageStyle(highlightedItem.background_image?.url)}
        >
          <CMSNavigationItem
            reference={highlightedItem.item[0]}
            maxDepth={maxDepth}
            activeItem={styles.active}
          />
        </li>
      )}
    </div>
  );
};
export default CMSSecondaryMenuV3;
